import type { RouteRecordRaw } from 'vue-router'

import { routeHome } from '@/routers/routes/mainRoutes/routeHome/homeRoutes'
import { redirectAuth } from '@/routers/routes/routeAuth'
import { useAuthStore } from '@/stores/auth'
import { useSidebarStore } from '@/stores/sidebar'
import { isEnvironmentDevelopment } from '@/utilities/environments'
import { ensureNoAuthRoutes, ensureRootRoutePath } from '@/utilities/routers'

import { route2WorkAIRoot } from './mainRoutes/route2WorkAI'
import { routeAccountingsRoot } from './mainRoutes/routeAccountings'
import { routeActivitiesRoot } from './mainRoutes/routeActivities'
import { routeBuyingRoot } from './mainRoutes/routeBuying'
import { routeFileSystemRoot } from './mainRoutes/routeFileSystem'
import { routeHRRoot } from './mainRoutes/routeHR'
import { routeMarketingRoot } from './mainRoutes/routeMarketing'
import { routeProjectRoot } from './mainRoutes/routeProjects'
import { routeRelationshipsRoot } from './mainRoutes/routeRelationships'
import { routeSalesRoot } from './mainRoutes/routeSales'
import { routeServicesRoot } from './mainRoutes/routeServices'
import { routeSettingsRoot } from './mainRoutes/routeSettings'
import { routeStockRoot } from './mainRoutes/routeStock'

const routeMainLayoutHome: RouteRecordRaw = {
  ...routeHome,
  beforeEnter: async () => {
    const authStore = useAuthStore()
    await authStore.initAccessibleModules()

    const sidebarStore = useSidebarStore()
    await sidebarStore.initializeSidebarContext()

    // Users without any accessible module cannot use the app at all.
    return sidebarStore.getFirstMenuLink ? true : redirectAuth
  },
}

const routeMainLayoutRoot: RouteRecordRaw = {
  alias: ensureRootRoutePath('mainlayout'),
  children: [
    routeMainLayoutHome,
    routeRelationshipsRoot,
    routeSalesRoot,
    routeBuyingRoot,
    routeStockRoot,
    routeActivitiesRoot,
    routeServicesRoot,
    routeProjectRoot,
    routeHRRoot,
    routeAccountingsRoot,
    routeSettingsRoot,
    routeFileSystemRoot,
    route2WorkAIRoot,
    routeMarketingRoot,
  ],
  component: async () => {
    return await import('@/components/layouts/MainGridLayout.vue')
  },
  meta: {
    requireAuth: true,
  },
  name: 'mainlayout',
  path: '/',
  redirect: routeMainLayoutHome,
}

const routeCatchAll: RouteRecordRaw = {
  component: async () => await import('@/components/views/ErrorWrapperView.vue'),
  meta: {
    requireAuth: true,
  },
  name: 'error-catchall',
  path: '/:pathMatch(.*)*',
}

const developmentRoutes: RouteRecordRaw[] = []
routeMainLayoutRoot.children = [
  ...routeMainLayoutRoot.children,
  ...(isEnvironmentDevelopment ? ensureNoAuthRoutes(developmentRoutes) : []),
  routeCatchAll,
]

export { routeMainLayoutHome, routeMainLayoutRoot }
